<template>
  <div class="columns">
    <div class="column is-12">
      <div :style="boxStyles">
        <svg :style="svgStyle">
          <g :transform="`translate(${cut_spinner.box_styles.width/2},${cut_spinner.box_styles.height/2}) scale(1,-1)`">
            <circle :style="outerCircle"></circle>
            <path :style="arcStyle" :d="describeArc()" />
            <circle :style="strokeStyle" r=5 ></circle>
            <path :style="strokeStyle" :d="makeLine()" />
            <path :style="endArrowStyle" :d="makeEndArrow()"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { getCSSFromStyles } from '@/components/Common/StyleEditor/utils';
export default {
  name: "show-cut-spinner",
  props: {
    cut_spinner: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods:{
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      const angleInRadians = (angleInDegrees) * Math.PI / 180.0;

      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      };
    },   
    describeArc(){
      const extra=this.cut_spinner.stroke_width
      const radius=this.radius
      const endAngle = this.cut_spinner.circle_angle
      const end = this.polarToCartesian(0, 0, radius, endAngle);
      
      const largeArcFlag = endAngle - 0 <= 180 ? "0" : "1";
      let d = [
        "M", end.x, end.y,
        "L", 0+extra-5, 0,
        "L", radius, 0,
        "A", radius, radius, 0, largeArcFlag, 1,
            end.x, end.y
        ].join(" ");
      return d;
    }, 
    makeLine(){
      const radius=this.radius
      const end=this.polarToCartesian(0,0,radius,this.cut_spinner.spinner_angle)
      let d = [
          "M", 0, 0,
          "L", end.x, end.y
      ].join(" ");
      
      return d;
    },
    makeEndArrow(){
      const len=this.radius
      const extra=this.cut_spinner.stroke_width
      let d = [
        "M", 0, 5,
        "L", len-30-extra, 10,
        "L", len-extra-1, 0,
        "L", len-30-extra, -10,
        "L", 0, -5
      ].join(" ");
      return d;
    }
  },
  computed:{
      boxStyles(){
          return{
              ...getCSSFromStyles(this.cut_spinner.box_styles),
          }
      },
      strokeStyle(){
        return{
          "stroke":"black",  
          "stroke-width":`${this.cut_spinner.stroke_width}`,
        }
      },
      arcStyle(){
        return{
          ...this.strokeStyle,
          "fill":`${this.cut_spinner.arc1_styles.bg_color}` 
        }
      },
      svgStyle(){
        return{
          "height":`${this.cut_spinner.box_styles.height}`,
          "width":`${this.cut_spinner.box_styles.width}`
        }
      },
      endArrowStyle(){
        return{
            "transform":`rotate(${this.cut_spinner.spinner_angle}deg)`,
            ...this.strokeStyle

        }
      },
      radius(){
        if(this.cut_spinner.box_styles.width<this.cut_spinner.box_styles.height){
            return (this.cut_spinner.box_styles.width-2*this.cut_spinner.padding)/2
        }
        else{
            return (this.cut_spinner.box_styles.height-2*this.cut_spinner.padding)/2   
        }
      },
      outerCircle(){
        return{
                "fill":`${this.cut_spinner.arc2_styles.bg_color}`, 
                "r":`${this.radius}`,
                ...this.strokeStyle
        }
      }
  }
}

</script>
<style scoped></style>